import { HttpClient } from '@angular/common/http';
import { Injectable, Signal, signal } from '@angular/core';
import { environment } from '@env/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { User } from '@core/models';
import { UserStatus } from '@shared/enums';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class UserApiService extends BaseService<User> {
  protected roleFilter = signal<number | null>(null);
  protected statusFilter = signal<number[]>([UserStatus.ACTIVE]);

  constructor(http: HttpClient) {
    super(`${environment.baseUrl}/users`, http);
  }

  /** Define los filtros */

  getRoleFilter(): Signal<number | null> {
    return this.roleFilter;
  }

  getStatusFilter(): Signal<number[] | null> {
    return this.statusFilter;
  }

  setRoleFilter(roleId: number | null): void {
    this.roleFilter.set(roleId);
  }

  setStatusFilter(statusId: number[]): void {
    this.statusFilter.set(statusId);
  }

  /** Operaciones */

  updatePassword(password: string): Observable<User> {
    if (!this.selectedItem()) return throwError(() => 'No hay item seleccionado');

    return this.http.put<User>(`${this.apiUrl}/${this.selectedItemId()}/password`, { password })
      .pipe(catchError((err) => throwError(() => err.error.message)));
  }

  /** FILTROS */

  protected override filterFunctionSearch(user: User, query: string): boolean {
    return user.fullName.toLowerCase().includes(query) || user.notificationEmail.toLowerCase().includes(query) || user.username.toLowerCase().includes(query);
  }

  protected override applyAdditionalFilters(items: User[]): User[] {
    let filtered = [...items];

    if (this.roleFilter()) {
      filtered = filtered.filter((user) => user.roleId === this.roleFilter());
    }

    const filterValue = this.statusFilter();
    if (filterValue && filterValue.length) {
      filtered = filtered.filter((user) => filterValue.includes(user.statusId));
    }

    return filtered;
  }
}
